import { inject, Injectable, REQUEST } from '@angular/core';
import Bugsnag from '@bugsnag/js';
import { isClientSide } from '@tytapp/environment-utils';
import { injectRequest } from './request-context';

@Injectable()
export class BugsnagService {
    private request = injectRequest();

    addMetadata(section: string, values: Record<string, any>) {
        if (isClientSide() || REQUEST) {
            Bugsnag.addMetadata(section, values);
        }
    }
}